var scope_0 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/24008ea61146ef0e6e12314d40c698b2.js').default;
var scope_1 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/867577deb12cf521806afeb33dbb21db.js').default;
var scope_2 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    